<nav aria-label="breadcrumb">
  <ol>
    @for (
      item of breadCrumbItems;
      track trackByFn($index);
      let isFirst = $first;
      let isLast = $last
    ) {
      <li
        [attr.aria-current]="item.current ? 'page' : undefined"
        [class.compress]="item.compress"
      >
        @if (!isFirst) {
          <lib-icon
            name="chevron-right"
            class="d-none d-md-inline-block"
          ></lib-icon>
        }
        @if (item.current || !item.url) {
          <span>{{ item.title$ | async }}</span>
        }
        @if (!(item.current || !item.url)) {
          <a [routerLink]="item.url">{{ item.title$ | async }}</a>
        }
        @if (!isLast) {
          <lib-icon name="chevron-right" class="d-md-none"></lib-icon>
        }
      </li>
    }
  </ol>
</nav>
